import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "mobileServicesList", "toggleButton"];
  static classes = ["default", "active"];

  connect() {
    // Set initial state
    this.menuTarget.classList.remove("hidden");
    this.menuTarget.classList.add("flex", ...this.defaultClasses);
    this._handleKeydown = this._handleKeydown.bind(this);
  }

  toggle() {
    if (this.menuTarget.classList.contains(...this.activeClasses)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menuTarget.classList.remove(...this.defaultClasses);
    this.menuTarget.classList.add(...this.activeClasses);
    this.toggleButtonTarget.setAttribute("aria-expanded", "true");
    this.toggleButtonTarget.setAttribute("aria-label", this.toggleButtonTarget.getAttribute("aria-label").replace(this._openLabel, this._closeLabel));
    document.addEventListener("keydown", this._handleKeydown);
    this.menuTarget.querySelector("a")?.focus();
  }

  close() {
    this.menuTarget.classList.remove(...this.activeClasses);
    this.menuTarget.classList.add(...this.defaultClasses);
    this.toggleButtonTarget.setAttribute("aria-expanded", "false");
    this.toggleButtonTarget.setAttribute("aria-label", this.toggleButtonTarget.getAttribute("aria-label").replace(this._closeLabel, this._openLabel));
    document.removeEventListener("keydown", this._handleKeydown);
    this.toggleButtonTarget.focus();
  }

  toggleMobileServicesList(e) {
    e.preventDefault();
    this.mobileServicesListTarget.classList.toggle("hidden");
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  get _openLabel() {
    return document.documentElement.lang === "fr" ? "Ouvrir le menu" : "Open menu";
  }

  get _closeLabel() {
    return document.documentElement.lang === "fr" ? "Fermer le menu" : "Close menu";
  }
}
